import axios from "axios";

const baseUrl = process.env.REACT_APP_QCX_API_BASE_URL! + "/"
    + process.env.REACT_APP_RELATORIOS_API_NFEMITIDAS!;

const generateSpreadsheetNfEmitidas = async (
    dataInicio: string,
    dataFim: string,
    token: string,
    unidadeId: number,
    unidadesNegocioID: string,
    clientesId: string[],
    origem: string,
    status: string // Added parameter
) => {
    const params = new URLSearchParams();
    params.set('unidadesDeNegocioID', unidadesNegocioID);
    params.set("inicio", dataInicio);
    params.set("fim", dataFim);
    if (clientesId.length > 0) {
        params.set('clientesId', clientesId.join(','));
    }
    if (origem) {
        params.set('origem', origem);
    }
    if (status) {
        params.set('status', status); // Include status in params
    }

    let message = null;

    try {
        const response = await axios.get(
            `${baseUrl}?${params.toString()}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                    quickcomexTenant: unidadeId,
                },
                responseType: "blob",
            }
        );

        if (response.status === 200) { // Successful response
            const file = new File([response.data], "relatorioNfEmitidas.xlsx", {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(file);
            const a = document.createElement("a");
            a.href = url;
            a.download = file.name;
            a.click();
        } else {
            message = await response.data.text();
        }
    } catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response && error.response.data) {
                message = await error.response.data.text();
            } else {
                message = "Erro inesperado";
            }
        } else {
            message = "Erro inesperado";
        }
    }
    return message;
};


export { generateSpreadsheetNfEmitidas };
